import {Config} from '../config';
import {HelpUrls} from './help-urls';

export const defaultConfig: Config = {
    mode: '',
    host: 'https://test.depositfix.com/',
    cssFile: '',
    s3Host: 'https://depositfix.s3.amazonaws.com/',
    hubSpotFormId: '',
    userId: '',
    amount: '',
    discountAmount: 0,
    discountPercent: 0,
    finalAmount: 0,
    productName: '',
    subscriptionPlan: '',
    dynamicPlan: false,
    portalId: '',
    stripePubKey: '',
    stripeToken: '',
    hubspotForm: {},
    hubspotFormObj: {},
    discount: false,
    stripeDiscount: false,
    discountId: '',
    stripeCouponId: '',
    currency: 'USD',
    currencySign: '$',
    termsUrl: '',
    submitBtnText: 'Buy Now',
    stripeAPI: {},
    stripeElement: {},
    stripeElementStyles: {base: {fontSize: '18px'}},
    hsContext: {},
    followUpEmailId: '',
    followUpEmailCampaignId: '',
    formContext: {},
    products: [],
    showQuantity: false,
    quantity: 0,
    fallbackRedirectUrl: HelpUrls.REDIRECT_AFTER_PAYMENT,
    lambdaUrl: 'https://9j11ty5tq3.execute-api.us-east-1.amazonaws.com/prod',
    loggerUrl: 'https://woetzkq6v6.execute-api.us-east-1.amazonaws.com/prod',
    paymentType: '',
    paymentMethod: [],
    subscriptions: [],
    redirectUrl: '',
    paypalEmail: '',
    subscriptionAmount: '',
    planInterval: '',
    productsList: [],
    tax: 0,
    prices: [],
    countdown: {seconds: 0, finalPrice: 0, finalCallback: {}}
};
